<template>
  <div class="page-container" ref="Draw" id="drawcontainer">
    <div class="bigscroller">
      <Menu />
      <MobileMenu />
      <section id="draw">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="CDraw"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <div class="mRetailers">
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/MenuM";
import MobileMenu from "@/components/MobileMenu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
export default {
    name: "Draw",
    props: ["id"],
    components: {
        Menu,
        MobileMenu,
    },
    computed: {
        ...mapGetters([
            "getActiveSection",
            "getTriggerSpring",
            "getEdgeScrolling",
            "getScrollMotion",
        ]),
    },
    created() {},
    mounted() {
        //this.checkRouteForInitialScroll();
        VueScrollTo.scrollTo(`#app`, 1, {
            container: "body",
            easing: "linear",
            offset: 0,
            force: true,
            cancelable: true,
            // onStart: function(element) {},
            // onDone: function(element) {},
            // onCancel: function() {},
            x: false,
            y: true,
        });
    },
    data() {
        return {
            showModal: false,
            fixedLel: true,
            placesDirections: {
                drawUp: (scrolled) => {
                    this.setActiveSection("draw");
                    document.getElementById("app").scroll(0, scrolled);
                },
                drawDown: (scrolled) => {
                    this.setActiveSection("draw");
                    document.getElementById("app").scroll(0, scrolled);
                },
            },
        };
    },
    methods: {
        ...mapActions({
            goToSection: "goToSection",
            setActiveSection: "setActiveSection",
            resetEdgeScrollingAction: "resetEdgeScrolling",
            setEdgeScrollingAction: "setEdgeScrolling",
        }),
        visibilityChanged(isVisible, entry) {
        //  console.log("isvisible1",entry.target.offsetParent)
            if (isVisible) {
                this.$router.push({ name: entry.target.offsetParent.id }).catch(err => {
                // Ignore the vuex err regarding  navigating to the page they are already on.
                    if (
                        err.name !== 'NavigationDuplicated' &&
                        !err.message.includes('Avoided redundant navigation to current location')
                    ) {
                    // But print any other errors to the console
                        throw err;
                    }
                });
                this.setActiveSection({
                    willScroll: false,
                    section: entry.target.offsetParent.id,
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/draw.scss";
@import "~@/styles/variables.scss";
</style>